<template>
    <div empty question :id="`question-${questionData.number}`" @keyup.enter="submitQuestion">
        <questionheader :questionData="questionData" />

        <questionfooter :questionData="questionData" />
    </div>
</template>

<script>
import mixins from "@/global/mixins";

export default {
    name: `empty-question`,
    mixins: [mixins.defaultQuestion],
    computed: {
        answersGiven() {
            return this.questionData.answers.filter((answer) => answer.isChecked).length;
        },
    },
    created: function () {
        this.questionData.answers[0].isChecked = true;
        if (this.questionData.isDeadEnd) {
            this.$store.commit(`changeGlobal`, {
                variableName: `disableNavButtons`,
                newValue: true,
            });
        }
    },
};
</script>